import { Api } from '@automapa/svelte-automapa-template';
import { type QueriesType, QueriesTypeSchema } from '../telematics/types';
import { z } from 'zod';

// curl 'http://localhost:3001/api/job/count/query?page%5Blimit%5D=1&page%5Boffset%5D=0&sort%5Bby%5D=id&sort%5Bdir%5D=asc&fswitch=feature_1355_auto_confirm,feature_1360_track_vehicles,feature_jobs_assigned_to_vehicle_by_bulk,feature_enable_to_change_job_color_method,feature_enable_route_distance_and_cost_dashboards,feature_enable_route_cost_settings,feature_enable_limit_vehicles_rejecting,feature_tetris,feature_enable_limit_vehicles_when_planning,feature_enable_gantt_in_delivery_list,feature_enable_gantt_couriers_dashboards,feature_wait_for_time_window,feature_planning_export_enabled,feature_ux_improvements,feature_reverse_route,feature_add_custom_config,feature_delivery_list_enabled,feature_add_warehouse_in_the_middle_of_the_route' \
//   -X POST \
//   -H 'Accept: application/json, text/plain, */*' \
//   -H 'Content-Type: application/json' \
//   -H 'Token: 572974bb0b2976e7813f22e3da14ca57' \
//   --data-raw '{"coords_accepted":true,"process_stage":{"$lt":20},"completed_as_planned":null}'

export class DaysWithJobsToProcessApi {
    public static async getDaysWithJobsToProcess(api: Api, days: string[], counters: string[]): Promise<any> {
        return api.getData<{ days: string[], counters: string[] }, any>(
            'post',
            '/scenario/get_days_with_jobs_to_process',
            { days, counters },
            z.object({ days: z.array(z.string()), counters: z.array(z.string()) }),
            z.any()
        );
    }
}
